/* eslint-disable max-len */
/* eslint-disable no-plusplus */
/* eslint-disable no-continue */
// eslint-disable-next-line no-unused-vars
class cookieUtils {
  static getToken() {
    return this.getCookieValue(this.tokenCookieName);
  }

  /**
     * Sets a cookie value for given key.
     * This is a simple implementation created to be used by ABP.
     * Please use a complete cookie library if you need.
     * @param {string} key
     * @param {string} value
     * @param {Date} expireDate (optional). If not specified the cookie will expire at the end of session.
     * @param {string} path (optional)
     */
  static setCookieValue(key: string, value: string | number | boolean, expireDate: Date, path: string, domain: undefined) {
    let cookieValue = `${encodeURIComponent(key)}=`;

    if (value) {
      cookieValue += encodeURIComponent(value);
    }

    if (expireDate) {
      cookieValue = `${cookieValue}; expires=${expireDate.toUTCString()}`;
    }

    if (path) {
      cookieValue = `${cookieValue}; path=${path}`;
    }

    if (domain) {
      cookieValue = `${cookieValue}; domain=${domain}`;
    }

    document.cookie = cookieValue;
    return cookieValue;
  }

  /**
     * Gets a cookie with given key.
     * This is a simple implementation created to be used by ABP.
     * Please use a complete cookie library if you need.
     * @param {string} key
     * @returns {string} Cookie value or null
     */
  static getCookieValue(key: string) {
    const equalities = document.cookie.split('; ');
    for (let i = 0; i < equalities.length; i++) {
      if (!equalities[i]) {
        continue;
      }

      const splitted = equalities[i].split('=');
      if (splitted.length !== 2) {
        continue;
      }

      if (decodeURIComponent(splitted[0]) === key) {
        return decodeURIComponent(splitted[1] || '');
      }
    }

    return null;
  }

  /**
     * Deletes cookie for given key.
     * This is a simple implementation created to be used by ABP.
     * Please use a complete cookie library if you need.
     * @param {string} key
     * @param {string} path (optional)
     */
  static deleteCookie(key: string | number | boolean, path: undefined) {
    let cookieValue = `${encodeURIComponent(key)}=`;
    cookieValue = `${cookieValue}; expires=${(new Date(new Date().getTime() - 86400000)).toUTCString()}`;
    if (path) {
      cookieValue = `${cookieValue}; path=${path}`;
    }
    document.cookie = cookieValue;
  }

  /**
     * Gets the domain of given url
     * @param {string} url
     * @returns {string}
     */
  static getDomain(url: string) {
    const domainRegex = /(https?:){0,1}\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;
    const matches = domainRegex.exec(url);
    return (matches && matches[2]) ? matches[2] : '';
  }

  static appPath() {
    return '/';
  }

  static tokenCookieName = 'SaaScada.AuthToken';
}

export default cookieUtils;